import React from 'react';
import { useSelector } from 'react-redux';

import * as lessonViewSelectors from 'common.components/lesson-view.store/selectors';

import { CustomLessonReadonlyView } from './custom-lesson-readonly-view';

export const CustomLessonReadonlyViewContainer = () => {
    const selectedTab = useSelector(lessonViewSelectors.getSelectedTab);

    return <CustomLessonReadonlyView selectedTab={selectedTab} />;
};
